import {Component, AfterViewInit, EventEmitter, Output} from '@angular/core';
import {
  NgbModal,
  ModalDismissReasons,
  NgbPanelChangeEvent,
  NgbCarouselConfig
} from '@ng-bootstrap/ng-bootstrap';
import {PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
import {TranslateService} from '@ngx-translate/core';
import {GlobalStoreService} from "../../shared/_services/global-store.service";
import {PusherService} from "../../Chat/pusher.service";
import {ToastrService} from "ngx-toastr";
import {ChatService} from "../../Chat/chat.service";
import { Howl } from 'howler';
import {Router} from "@angular/router";

declare var $: any;

@Component({
  selector: 'app-vertical-navigation',
  templateUrl: './vertical-navigation.component.html'
})
export class VerticalNavigationComponent implements AfterViewInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  public config: PerfectScrollbarConfigInterface = {};


  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: 'us'
  }

  notifiche: number;
  private utenteAutenticatoId: number;
  private sound;
  Messaggi: {
    id_destinatario: number;
    messaggio: string;
    letto: string,
    tipo?: string;
    file_name?: string;
    file_extension?: string;
    file_content?: string;
  }[];


  constructor(private toastr: ToastrService, private router:  Router, private modalService: NgbModal, private translate: TranslateService, public store: GlobalStoreService, public pusherService: PusherService, private chatService: ChatService) {
    translate.setDefaultLang('en');
    store.$numNotifiche.subscribe(data => this.notifiche = data)
    this.sound = new Howl({
      src: ['assets/audio.mp3']
    });
  }

  changeLanguage(lang: any) {
    this.translate.use(lang.code)
    this.selectedLanguage = lang;
  }

  showNotificationToastr(name: string): void {
    const senderName = name;

    const toastrOptions = {
      closeButton: true,
      timeOut: 5000,
      extendedTimeOut: 2000
    };

    this.toastr.info(
      `<div class="d-flex align-items-center">
         <div class="me-3">
           <i class="fas fa-bell fa-3x"></i>
         </div>
         <div>
           <div class="fw-bold pl-2"><strong>${senderName}</strong></div>
           <div class="text-nowrap overflow-hidden text-truncate pl-2" >Ti ha scritto</div>
         </div>
       </div>`,
      '',
      {
        enableHtml: true,
        toastClass: 'ngx-toastr',
        timeOut: toastrOptions.timeOut,
        extendedTimeOut: toastrOptions.extendedTimeOut
      }
    );
  }
  OpenChat( ){
    var link = '/chat/messages/entry';
    this.openTabWithAngularRoute(link);
  }
  openTabWithAngularRoute(routePath: string) {
    const urlTree = this.router.createUrlTree([routePath]);
    const fullUrl = this.router.serializeUrl(urlTree);
    window.open(fullUrl, '_blank');
  }


  ngAfterViewInit() {
    const currentUserString = localStorage.getItem('currentUser');
    if (currentUserString) {
      const currentUser = JSON.parse(currentUserString);
      this.utenteAutenticatoId = currentUser.id;
    }
    this.chatService.getUnreadMessages( 1,20).subscribe(data =>{
      this.Messaggi = data.messages;
      console.log("Messaggi: ", data);
    })
    this.pusherService.subscribe('chat-channel', 'new-message', (data: any) => {
      if ((data.message.id_mittente != this.utenteAutenticatoId) && (data.message.id_destinatario == this.utenteAutenticatoId) ) {
        this.chatService.getUser(data.message.id_mittente).subscribe(
          data => {
            console.log("Emetto il toastr");
            this.showNotificationToastr(data.utente.username);
            this.sound.play();
          },
          error => {
            console.log("Errore nel recupero dell'utente");
          }
        )
      }
      this.chatService.getUnreadMessages( 1,20).subscribe(data =>{
        this.Messaggi = data.messages;
        console.log("Messaggi: ", data);
      })
    });
  }
}
